import {
  Stack,
  Heading,
  Columns,
  Column,
  TextField,
} from 'braid-design-system';
import { useFormContext } from 'react-hook-form';

export const PersonalDetails = () => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();

  return (
    <Stack space="medium">
      <Heading level="3">Personal details</Heading>
      <Columns space="gutter">
        <Column>
          <TextField
            id="firstName"
            label="First name"
            message={errors.firstName?.message as string}
            onClear={() => setValue('firstName', '')}
            tone={Boolean(errors.firstName) ? 'critical' : 'neutral'}
            {...register('firstName')}
            value={watch('firstName')}
          />
        </Column>
        <Column>
          <TextField
            id="lastName"
            label="Last name"
            message={errors.lastName?.message as string}
            onClear={() => setValue('lastName', '')}
            tone={Boolean(errors.lastName) ? 'critical' : 'neutral'}
            {...register('lastName')}
            value={watch('lastName')}
          />
        </Column>
      </Columns>
      <TextField
        id="jobTitle"
        label="Job title"
        message={errors.jobTitle?.message as string}
        onClear={() => setValue('jobTitle', '')}
        tone={Boolean(errors.jobTitle) ? 'critical' : 'neutral'}
        {...register('jobTitle')}
        value={watch('jobTitle')}
      />
      <TextField
        id="phone"
        label="Phone"
        message={errors.phone?.message as string}
        onClear={() => setValue('phone', '')}
        tone={Boolean(errors.phone) ? 'critical' : 'neutral'}
        {...register('phone')}
        value={watch('phone')}
      />
      <TextField
        id="email"
        label="Email"
        onClear={() => setValue('email', '')}
        message={errors.email?.message as string}
        tone={Boolean(errors.email) ? 'critical' : 'neutral'}
        {...register('email')}
        value={watch('email')}
      />
    </Stack>
  );
};
